import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';

import {
  GET_CHANCE_GAMES_COUPONS_REQUEST,
  GET_CHANCE_GAMES_COUPONS_SUCCESS,
  GET_CHANCE_GAMES_COUPONS_FAILURE
} from 'Store/constants';

import { apiURLMapping, tabNameMapping } from 'Pages/ChanceGames/cgUtils';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getCGCoupons = (gameType, tabName, resetPagination = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_COUPONS_REQUEST,
      payload: { resetPagination }
    });

    const res = await axios({
      method: 'post',
      url: `${API_GATEWAY}/mobile/digital-lottery/v2/coupons`,
      data: {
        ascending: false,
        couponStatus: tabNameMapping[tabName],
        gameType: apiURLMapping[gameType],
        pageIndex: resetPagination ? 0 : getState().chanceGames.cgCoupons.pagination.pageIndex,
        pageSize: getState().chanceGames.cgCoupons.pagination.pageSize
      }
    });

    dispatch({
      type: GET_CHANCE_GAMES_COUPONS_SUCCESS,
      payload: { coupons: res.data.coupons, resetPagination }
    });

  } catch (e) {
    dispatch({
      type: GET_CHANCE_GAMES_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};
